const DEFAULT_VALIDATION_MESSAGE =
  'Ocorreu um erro durante a atualização, tente novamente';

type StrapiValidationError = {
  response?: {
    data?: {
      error?: {
        message?: string;
        details?: {
          errors?: Array<{ message?: string }>;
        };
      };
    };
  };
};

export const getStrapiValidationMessage = (
  error: StrapiValidationError,
  fallbackMessage = DEFAULT_VALIDATION_MESSAGE,
): string => {
  const apiError = error?.response?.data?.error;
  const message = apiError?.message;

  if (
    typeof message === 'string' &&
    message.includes('occurred') &&
    apiError?.details?.errors?.[0]?.message
  ) {
    return apiError.details.errors[0].message;
  }

  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  return fallbackMessage;
};
